import { Link } from "react-router-dom";
import Logo from "../../../assets/icons/OircLogo2.png";

export const OircLogo = () => {
  return (
    <Link to="/" className="header__krk">
      <img  src={Logo} alt="Логотип"></img>
    </Link>
  );
};
